export const VideoObjectId = 'Video';

export enum VideoObjectAttributes {
  TITLE = 'title',
  TAGS = 'tags',
  BLOB = 'blob',
  VISIBLE_IN_SEARCH = 'visibleInSearch',
}
